module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Light.fab3c31a.woff";